angular.module('impactx.catalog').controller('CatalogRuleCheckItemsListCtrl',
    CatalogRuleCheckItemsListCtrl);

CatalogRuleCheckItemsListCtrl.$inject = ['$routeParams', 'selectedListItems', '$mdDialog', 'CatalogRuleService', 'OneTimeDataTransporter'];

function CatalogRuleCheckItemsListCtrl($routeParams, selectedListItems, $mdDialog, CatalogRuleService, OneTimeDataTransporter) {
    var self = this;
    var idOfResultLink = 0;
    var resultLink = null;

    this.getCatalogrulecheckitemdetailLink = function () {
        return "catalogrulecheckitemdetail/" + selectedListItems.getFirstSelectedId();
    };

    this.canViewCatalogrulecheckitemdetail = function () {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 && selectedItem.isStatisticRule.value && !selectedItem.isImportRule.value &&
            selectedListItems.getFirstSelectedItem().poTable !== "catrule_product_label_statistic";
    };

    this.canViewCatalogRuleImportError = function () {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 && !selectedItem.isStatisticRule.value && selectedItem.isImportRule.value;
    };

    this.canViewCatalogRuleError = function () {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 && !selectedItem.isStatisticRule.value && !selectedItem.isImportRule.value && selectedItem.isCustomCheckScope.value;
    };


    this.redirectToCheckedOutCatalogList = function () {
        if (selectedListItems.getFirstSelectedItem()) {
            if (selectedListItems.getFirstSelectedId() !== idOfResultLink) {
                resultLink = "checkedincataloglist/" + $routeParams.catId + "/cmrlId/" + selectedListItems.getFirstSelectedId() + "/cmrlName/" + selectedListItems.getFirstSelectedItem().numberOfErrorRules;
                idOfResultLink = selectedListItems.getFirstSelectedId();
            }
            OneTimeDataTransporter.setAndRedirect({cmrlName: selectedListItems.getFirstSelectedItem().description}, null, resultLink);
        }
    };

    this.openCatalogRuleImportErrorDialog = function (event) {
        if (selectedListItems.getFirstSelectedItem().isImportRule.value) {
            $mdDialog.show({
                controller: "CatalogRuleCheckImportErrorCtrl",
                controllerAs: 'catalogRuleCheckImportErrorCtrl',
                templateUrl: 'modules/catalog/templates/catalog-rule-check-import-error.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: event,
                locals: {
                    cmrliId: selectedListItems.getFirstSelectedId(),
                    catId: $routeParams.catId
                },
                bindToController: true
            })

        }
    };

    this.openCatalogRuleErrorDialog = function (event) {
        if (selectedListItems.getFirstSelectedItem().isCustomCheckScope.value) {
            $mdDialog.show({
                controller: "CatalogRuleCheckErrorCtrl",
                controllerAs: 'catalogRuleCheckErrorCtrl',
                templateUrl: 'modules/catalog/templates/catalog-rule-check-error.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: event,
                locals: {
                    cmrliId: selectedListItems.getFirstSelectedId(),
                    catId: $routeParams.catId
                },
                bindToController: true
            })

        }
    };

    this.canViewCheckedincataloglist = function () {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.numberOfErrorRules > 0 &&
            !selectedItem.isStatisticRule.value && !selectedItem.hideSearchCheckedIn.value && !selectedItem.isImportRule.value &&
            !selectedItem.isCustomCheckScope.value;
    };

    this.getSpecialListLink = function () {
        if (selectedListItems.getFirstSelectedItem()) {
            return selectedListItems.getFirstSelectedItem().poTable + "/" + selectedListItems.getFirstSelectedId();
        }
        return "";
    };

    this.hasSpecialListLink = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().numberOfErrorRules > 0 && selectedListItems.getFirstSelectedItem().hasSpecialList.value;
    };

    this.getPrintToken = function () {
        return impactX.isDefined(self, 'meta.additionalFields.printTokens.protocol');
    };

    this.ignore = function(){
        CatalogRuleService.ignoreRules($routeParams.catId, selectedListItems.getSelectedIds(), true);
    };

    this.unIgnore = function(){
        CatalogRuleService.unIgnoreRules($routeParams.catId, selectedListItems.getSelectedIds(), true);
    };

    this.canIgnoreRules = function (additionalFields) {
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i].ignoreFilter.value || selectedItems[i].cmriStatus != 1) {
                    return false;
                }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    this.canUnIgnoreRules = function(additionalFields){
        if (additionalFields && additionalFields.canIgnoreRules && selectedListItems.isMultiSelection())
        {
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (!selectedItems[i].ignoreFilter.value || selectedItems[i].cmriStatus != 1) {
                    return false;
                }
            }
            return true;
        }
        else
        {
            return false;
        }
    };

    var buttonDefinition = [
        {
            label: "printProtocol",
            type: 'print',
            condition: selectedListItems.isNoSelection,
            process: 'CatalogRule',
            params: {
                printTokenFunction: self.getPrintToken
            }
        },
        {
            label: "details",
            action: self.redirectToCheckedOutCatalogList,
            condition: self.canViewCheckedincataloglist,
            process: 'CatalogRule'
        },
        {
            label: "details",
            linkFunction: self.getCatalogrulecheckitemdetailLink,
            type: 'link',
            condition: self.canViewCatalogrulecheckitemdetail,
            process: 'CatalogRule'
        },
        {
            label: "details",
            action: self.openCatalogRuleImportErrorDialog,
            condition: self.canViewCatalogRuleImportError,
            process: 'CatalogRule'
        },
        {
            label: "details",
            action: self.openCatalogRuleErrorDialog,
            condition: self.canViewCatalogRuleError,
            process: 'CatalogRule'
        },
        {
            label: "catruleresultlist",
            linkFunction: self.getSpecialListLink,
            type: 'link',
            condition: self.hasSpecialListLink,
            process: 'CatalogRule'
        },
        {
            label: "ignore",
            action: self.ignore,
            condition: self.canIgnoreRules,
            process: 'CatalogRuleIgnore'
        },
        {
            label: "unignore",
            action: self.unIgnore,
            condition: self.canUnIgnoreRules,
            process: 'CatalogRuleIgnore'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/catalog/templates/catalogrulecheckitemslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalog/rulecheckitems',
        id: "catalogrulecheckitemslist",
        params: {'cmrlId': $routeParams.cmrlId},
        cmrlId: $routeParams.cmrlId,
        catId: $routeParams.catId,
        excelExport: true,
        buttonDefinition: buttonDefinition,
        valuesInteger: [
            {name: 'CatId', value: $routeParams.catId},
            {name: 'CmrlId', value: $routeParams.cmrlId}
        ]
    };
    this.getMeta = function () {
        return this.meta;
    }
}